import { render, staticRenderFns } from "./UmbForms.vue?vue&type=template&id=36797b54&scoped=true"
import script from "./UmbForms.vue?vue&type=script&lang=ts"
export * from "./UmbForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36797b54",
  null
  
)

export default component.exports